import React, { useState } from 'react'
import type { Dashboard } from '../../config/config'

type Props = {
  dashboard: Dashboard
  height?: string
}

const DashboardEmbed: React.FC<Props> = ({ dashboard, height = 'min(68vh, 900px)' }) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <div className="w-full bg-white">
      {/* Google auth notice */}
      <div className="px-4 py-3 bg-blue-50 border-b border-blue-200 flex flex-wrap items-center gap-2 text-sm text-blue-800">
        <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
        </svg>
        <span>
          This dashboard requires access to Data Studio. Contact laramos@riddellsports.com to request access.
        </span>
      </div>

      <div className="relative w-full">
        {!loaded && (
          <div className="absolute inset-0 flex items-center justify-center bg-neutral-50">
            <div className="text-sm text-neutral-500">Loading dashboard…</div>
          </div>
        )}

        <iframe
          title={dashboard.title}
          src={dashboard.url}
          loading="lazy"
          allowFullScreen
          {...(dashboard.sandbox ? { sandbox: dashboard.sandbox } : {})}
          className="w-full border-0 block"
          style={{ height }}
          onLoad={() => setLoaded(true)}
        />
      </div>
    </div>
  )
}

export default DashboardEmbed
